// Core
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import { GeckoRow, GeckoIcon } from 'ui';

// Style
import './style.css';

export default class WidgetTotalHeader extends Component {
  /**
   * Is the primary value more than the secondary value
   *
   * @return bool
   */
  isUp() {
    return this.props.primary > this.props.secondary;
  }

  /**
   * Get the difference between the primary value and the secondary value
   *
   * TODO: this probably wont handle equal values very well and should be improved
   * @return integer
   */
  getTrendDiff() {
    return Math.abs(this.props.primary - this.props.secondary);
  }

  /**
   * Get an icon to represent the direction of the trend
   *
   * @return string
   */
  getTrendIcon() {
    if (this.isUp()) {
      return 'fas fa-caret-up';
    }

    return 'fas fa-caret-down';
  }

  /**
   * Get a color to represent the direction of the trend
   *
   * @return string
   */
  getTrendColor() {
    if (this.isUp()) {
      return this.props.trendUpColor;
    }

    return this.props.trendDownColor;
  }

  /**
   * Render the primary value
   *
   * @return element
   */
  renderPrimary() {
    if (!this.props.showPrimary) {
      return null;
    }

    if (this.props.renderPrimary) {
      return this.props.renderPrimary();
    }

    let suffix = null;

    if (this.props.suffix) {
      suffix = this.props.suffix;
    }

    return (
      <div className="value primary">
        {this.props.primary} {suffix}
      </div>
    );
  }

  /**
   * Render the secondary value
   * This can be disabled by passing the showSecondary prop as false
   *
   * @return element
   */
  renderSecondary() {
    if (!this.props.showSecondary) {
      return null;
    }

    if (this.props.renderSecondary) {
      return this.props.renderSecondary();
    }

    return (
      <div className="float-left value secondary">
        <span style={{ color: this.getTrendColor() }}>
          <GeckoIcon icon={this.getTrendIcon()} />
          {this.getTrendDiff()}
        </span>{' '}
        from previous period
      </div>
    );
  }

  render() {
    return (
      <GeckoRow>
        <div className="col">
          {this.renderPrimary()}
          {this.renderSecondary()}
        </div>
      </GeckoRow>
    );
  }
}

WidgetTotalHeader.propTypes = {
  primary: PropTypes.number,
  secondary: PropTypes.number,
  trendUpColor: PropTypes.string,
  trendDownColor: PropTypes.string,
  showPrimary: PropTypes.bool,
  showSecondary: PropTypes.bool,
};

WidgetTotalHeader.defaultProps = {
  primary: 0,
  secondary: 0,
  trendUpColor: '#4caf50',
  trendDownColor: '#f44336',
  showPrimary: true,
  showSecondary: true,
};
